import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TasksResponse } from "../../models/Task";

// ToDo Task interface
interface ToDoTask {
	id: number;
	batchId?: string;
	targetType?: string;
	taskCategory?: string;
	taskSubcategory?: string;
	taskName: string;
	description: string;
	assignedByName?: string;
	assignedToName?: string;
	durationInHours: number;
	status: string;
	date?: string;
	remark?: string;
	taskGivenBy?: any;
	taskGivenTo?: any;
	name?: string;
	givenBy?: string;
	for?: string;
	duration?: string;
	remarks?: string;
}

// ToDo Tasks Response interface
interface ToDoTasksResponse {
	currentPage: number;
	totalItems: number;
	totalPages: number;
	content: ToDoTask[];
}

// Types for the new APIs
interface CreateToDoTaskRequest {
	id: number;
	batchId?: string;
	targetType: string;
	taskCategory: string;
	taskSubcategory?: string;
	taskName: string;
	description?: string;
	taskGivenById: number;
	durationInHours: number;
	date?: string;
	status: string;
	remark: string;
}

interface UpdateTaskStatusRequest {
	taskId: number;
	status: string;
}

export const ToDoApi = createApi({
	baseQuery: axiosBaseQuery({
		baseUrl: pyrotchBaseUrl + "v1/",
	}),
	reducerPath: "todoApi",
	tagTypes: ["ToDoTask"],
			endpoints: (build) => ({
		getToDoTasks: build.query<
			ToDoTasksResponse,
			{
				page?: number;
				size?: number;
				search?: string;
				status?: "NEW" | "IN_PROGRESS" | "COMPLETED";
				filterUser?: number;
			}
		>({
			query: ({ page = 0, size = 10, search, status, filterUser } = {}) => {
				const params: Record<string, string | number> = { page, size };
				if (search) params.search = search;
				if (status) params.status = status;
				if (filterUser !== undefined) params.filterUser = filterUser;
				return {
					url: `todo-tasks`,
					method: "GET",
					params,
				};
			},
			providesTags: ["ToDoTask"],
		}),
		createToDoTask: build.mutation<any, CreateToDoTaskRequest>({
			query: (taskData) => ({
				url: `todo-tasks`,
				method: "POST",
				data: taskData,
			}),
			invalidatesTags: ["ToDoTask"],
		}),
		updateTaskStatus: build.mutation<any, UpdateTaskStatusRequest>({
			query: ({ taskId, status }) => ({
				url: `todo-tasks/${taskId}/status`,
				method: "PATCH",
				params: { status },
			}),
			invalidatesTags: ["ToDoTask"],
		}),
		deleteToDoTask: build.mutation<any, { taskId: number }>({
			query: ({ taskId }) => ({
				url: `todo-tasks/delete/all`,
				method: "DELETE",
				params: { taskId },
			}),
			invalidatesTags: ["ToDoTask"],
		}),
		deleteAllToDoTasks: build.mutation<any, { taskId: number[] }>({
			query: ({ taskId }) => {
				const params = new URLSearchParams();
				taskId.forEach(id => params.append('taskId', id.toString()));
				return {
					url: `todo-tasks/delete/all?${params.toString()}`,
					method: "DELETE",
				};
			},
			invalidatesTags: ["ToDoTask"],
		}),
		
		importToDoTasks: build.mutation<any, { file: File; userId: number }>({
			query: ({ file, userId }) => {
				const formData = new FormData();
				formData.append('file', file);
				return {
					url: `todo-tasks/import?userId=${userId}`,
					method: "POST",
					data: formData,
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				};
			},
			invalidatesTags: ["ToDoTask"],
		}),
		
		exportToDoTasks: build.mutation<Blob, { userId: number; startDate?: string; endDate?: string }>({
			query: ({ userId, startDate, endDate }) => {
			  let url = `todo-tasks/export?userId=${userId}`;
			  if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`;
			  if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`;
			  return {
				url,
				method: "GET",
				
				responseHandler: async (response: Response) => {
				  const blob = await response.blob();
				  console.log("Raw blob:", blob);
				  return blob; 
				},
			  };
			},
		  }),
	}),
});

export const { 
	useLazyGetToDoTasksQuery,
	useCreateToDoTaskMutation,
	useUpdateTaskStatusMutation,
	useDeleteToDoTaskMutation,
	useDeleteAllToDoTasksMutation,
	useImportToDoTasksMutation,
	useExportToDoTasksMutation
} = ToDoApi;
